import React from 'react';
import '../css/App.css';
import '../css/TopNav.css';
import more_icon from "../images/more_icon.svg";
import topprofile from "../images/topprofile.png";
import RightNav from "./RightNav";
import BotNav from "./BotNav";
import {withRouter} from "react-router";

class TopNav extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            name:props.name,
            nav_open:false,
            showBotNav:true,
            buy_list:[],
            fontSize:this.props.fontSize
        };

        this.handleNavOpen = this.handleNavOpen.bind(this);
    }

    componentWillMount() {
        if(this.props.showBotNav != null)
            this.setState({showBotNav:this.props.showBotNav});
        else
            this.setState({showBotNav:false});
    }

    componentWillReceiveProps(props) {
        this.setState({buy_list:props.productsList,fontSize:props.fontSize});

        if(props.showBotNav != null)
            this.setState({showBotNav:props.showBotNav});
    }

    render() {
        let botNav = (<div />);
        if(this.state.showBotNav != null && this.state.showBotNav)
            botNav = (<BotNav productsList={this.state.buy_list} />);
        return (
            <div>
                <div className={"topNav"}>
                    <img src={more_icon} id={"topNavMore"} onClick={this.handleNavOpen}  />
                    <div src={more_icon} id={"topNaveText"}>{this.state.name}</div>
                    <img src={topprofile} id={"topNavProfile"} onClick={()=>{this.props.history.push("/profile")}} />
                </div>
                <RightNav plusFont={this.props.plusFont} minusFont={this.props.minusFont} fontSize={this.state.fontSize} nav_open={this.state.nav_open} offNave={this.handleNavOpen}/>
                {botNav}
            </div>

        );
    }


    handleNavOpen(){
        this.setState({nav_open:!this.state.nav_open});
    }

}



export default withRouter(TopNav);
